// src/App.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// ------------------- Common Components -------------------
import Navbar from "./component/Common/Navbar";
import EmailAttachmentHandler from "./component/Common/EmailAttachmentHandler";

// ------------------- Main Pages -------------------
import HomePageComponent from "./component/homepage/homepage.component";
import PricePageComponent from "./component/pricepage/pricepage.component";
import AuthFormComponent from "./component/authform/authform.component";
import ForgotPasswordComponent from "./component/authform/forgotpassword.component";
import ContactUsComponent from "./component/ContactUs/ContactUsPage.component";
import SeoResultDashboard from "./component/SeoResultDashboard/SeoResultDashboard";

// ------------------- Dynamic Product Page -------------------
import ProductPageComponent from "./component/ProductPageComponent/ProductPageComponent";

// ------------------- Checkout Flow -------------------
import Checkout from "./component/Checkout/Checkout";
import PaymentPage from "./component/PaymentPage/PaymentPage";
import FreeActivation from "./component/FreeActivation/FreeActivation";

// -------------------- Profile Page --------------------
import ProfilePage from "./component/ProfilePage/ProfilePage";

// -------------------- Admin Pages --------------------
import AdminDemoRequests from "./component/AdminDemoRequests/AdminDemoRequests";
import CreateProduct from "./component/AdminCreateProducts/CreateProduct";
import AdminDraftReview from "./component/AdminDraftReview/AdminDraftReview";
import TestimonialManagement from "./component/AdminTestimonial/TestimonialManagement";
import AdminDashboard from "./component/AdminDashBoard/AdminDashBoard";

// ------------------- Protected Route -------------------
import AdminProtectedRoute from "./component/routes/AdminProtectedRoute";


// ------------------- Finance Layout -------------------
import FinanceLayout from "./Calculators/CommonComponents/FinanceLayout";
import FinancialLiteracyGuide from "./component/FinancialGuide/FinancialGuide";

const AppContent = () => {
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user") || "null");
  const token = localStorage.getItem("token");
  const isAuthenticated = !!(user && token);

  // Routes where Navbar should be hidden
  const noNavbarRoutes = ["/login", "/signup", "/forgot-password"];
  const shouldHideNavbar = noNavbarRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideNavbar && <Navbar />}

      <EmailAttachmentHandler user={user} isAuthenticated={isAuthenticated} />

      <div className={shouldHideNavbar ? "no-pad" : "with-pad"}></div>

      <Routes>
        {/* ----------- Public Routes ----------- */}
        <Route path="/" element={<HomePageComponent />} />
        <Route path="/pricing" element={<PricePageComponent />} />
        <Route path="/login" element={<AuthFormComponent />} />
        <Route path="/signup" element={<AuthFormComponent />} />
        <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
        <Route path="/contact" element={<ContactUsComponent />} />
        <Route path="/seo-results" element={<SeoResultDashboard />} />

        {/* ----------- Dynamic Product ----------- */}
        <Route path="/product/:productId" element={<ProductPageComponent />} />

        {/* ----------- Checkout Flow ----------- */}
        <Route path="/payment/checkout" element={<Checkout />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment/free-activation" element={<FreeActivation />} />

        {/* ----------- Profile ----------- */}
        <Route path="/profile" element={<ProfilePage />} />

        {/* ----------- PROTECTED ADMIN ROUTES ----------- */}
        <Route element={<AdminProtectedRoute />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/demo-requests" element={<AdminDemoRequests />} />
          <Route path="/admin/products" element={<CreateProduct />} />
          <Route path="/admin/draft-reviews" element={<AdminDraftReview />} />
          <Route path="/admin/testimonials" element={<TestimonialManagement />} />
        </Route>

        {/* ----------- Finance Section ----------- */}
        <Route path="/finance/*" element={<FinanceLayout />} />
        <Route path="/guide/*" element={<FinancialLiteracyGuide />} />
      </Routes>
    </>
  );
};

const App = () => <AppContent />;

export default App;
